import type { DEFAULT_FEATURES } from '@/config/features/featureFlags'
import type { SiteContextBasedIdEnum } from '@/enums/SiteContextBasedIdEnum'
import type { TranslationLanguage } from '@/lib/translate'

export type Currency = 'DKK' | 'SEK' | 'NOK' | 'EUR'
export type CountryCode = 'DK' | 'SE' | 'NO' | 'FI'

export type Timezone = 'Europe/Copenhagen' | 'Europe/Stockholm' | 'Europe/Oslo' | 'Europe/Helsinki'

export enum MarketEnum {
  mediq_dk = 'mediq_dk',
  mediq_se = 'mediq_se',
  mediq_no = 'mediq_no',
  mediq_fi = 'mediq_fi',
}

export interface TenantConfig {
  id: string
  marketId: MarketEnum
  countryCode: CountryCode
  countryName: string
  sapCatalogId: string
  marketSanity: Array<keyof typeof SiteContextBasedIdEnum>
  name: string
  domains: string[]
  languages: TranslationLanguage[]
  locale: string
  defaultLanguage: TranslationLanguage
  currency: Currency
  dateFormat: string
  timezone: Timezone
  postalCodeLength: number
  features: typeof DEFAULT_FEATURES
}

export type TenantRegistry = Record<string, TenantConfig>
